import { InputNumber } from "antd";
import styled from "styled-components";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-top: 35px;
  margin-bottom: 35px;
  box-sizing: border-box;
  padding: 0 16px;

  ${media.downTablet`
    margin-top: 24px;
    margin-bottom: 24px;
  `}
`;

export const InnerContainer = styled.div``;

export const ProductInfoWrapper = styled.div`
  display: flex;
  gap: 30px;
  align-items: flex-start;

  ${media.downTablet`
    flex-direction: column;
    gap: 16px;
    width: 100%;
  `}
`;

export const HeadingCostWrapper = styled.div`
  padding-top: 12px;
  width: 20%;
  flex: 1;
  min-width: 0;

  ${media.downTablet`
    width: 100%;
    padding-top: 0;
  `}
`;

export const StyledImage = styled.img`
  width: 141px;
  max-width: 100%;
  height: auto;
  flex-shrink: 0;

  ${media.downMobile`
    width: 100%;
    max-width: 200px;
  `}
`;

export const ProductHeading = styled.h4`
  margin: 0px;
  color: var(--Text2, #000);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
`;

export const ProductCost = styled.h5`
  margin: 0px;
  color: #9ca3af;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.48px;
`;

export const StyledQuantity = styled.div`
  display: flex;
  align-items: center;
  width: 65%;
  justify-content: flex-end;
  gap: 25%;

  ${media.downTablet`
    width: 100%;
    justify-content: space-between;
    gap: 16px;
  `}

  .ant-select-focused .ant-select-selector {
    border-color: #ed6928 !important;
  }
`;

export const StyledNumberInput = styled(InputNumber)`
  min-height: 44px;

  .ant-input-number-input {
    min-height: 44px;
  }

  .ant-input-number-handler-wrap {
    min-height: 44px;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;
